<!-- 批量生成溯源码 -->
<template>
    <div class="container">
        <!-- 注意事项 -->
        <Alert type="warning" show-icon>
            两种强制关注公众号方法
            <template slot="desc">
                <span class="alert-title">1、网页强制关注公众号</span><br/>
                若用户未关注公众号，在扫码进入网页时，系统将自动弹出公众号图片提示用户关注。<br/>
                开启条件：在对应批次中启用"强制关注公众号"功能，同时在第三方设置中开启"启用公众号"并填写对应的biz值并上传公众号二维码。<br/>
                <span class="alert-title">2、公众号入口强制关注</span><br/>
                用户需先关注公众号，再通过公众号菜单内的查询入口页扫码，才能查看溯源码内容。<br/>
                开启条件：在第三方设置中启用"强制关注公众号"功能，并填写公众号 ID。<br/>
                注意：此功能仅对开启后生成的所有溯源码生效。<br/>
            </template>
        </Alert>

        <!-- 基础关联 -->
        <div class="content section-basic">
            <div class="section-header">
                <Icon type="ios-link-outline" size="20" />
                <span>基础关联</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="140">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="选择批次：">
                            <Select
                                class="w200"
                                v-model="formData.batch_id"
                                clearable
                                filterable
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="item in batchList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.batch_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18" />
                                <div slot="content">
                                    <p>选择批次，没有请先在【批次管理】中【新增批次】</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="选择产品：">
                            <Select
                                class="w200"
                                v-model="formData.product_id"
                                clearable
                                filterable
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="item in productList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.product_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18" />
                                <div slot="content">
                                    <p>选择关联的产品，生成后可批量修改更换</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="选择经销商：">
                            <Select
                                class="w200"
                                v-model="formData.agent_id"
                                clearable
                                filterable
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="item in agentList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.agent_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18" />
                                <div slot="content">
                                    <p>选择默认的经销商，不选则暂时为空</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 溯源码配置 -->
        <div class="content section-code">
            <div class="section-header">
                <Icon type="ios-barcode-outline" size="20" />
                <span>溯源码配置</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="140">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="生成数量：">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formData.qrcode_count"
                                placeholder="建议单次2000条以内"
                            ></Input>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18" />
                                <div slot="content">
                                    <p>不得超过当前账号所剩数量</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="溯源码长度：">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formData.qrcode_length"
                                :placeholder="`请填写${qrcode_length_value}位已上数字`"
                            ></Input>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18" />
                                <div slot="content">
                                    <p>溯源码长度=前缀位数+随机码的位数+后缀位数，请填写{{ qrcode_length_value }}位已上数字。如需调整，请联系客服</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="溯源码类型：">
                            <Select
                                class="w200"
                                v-model="formData.qrcode_type"
                                clearable
                                filterable
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="item in typeList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="溯源码前缀：">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formData.qrcode_prefix"
                                placeholder="选填"
                            ></Input>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18" />
                                <div slot="content">
                                    <p>前缀可用于溯源码有特殊指定规则的场景(选填)</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="溯源码后缀：">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formData.qrcode_suffix"
                                placeholder="选填"
                            ></Input>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon class="cursor-p ml8" type="md-help-circle" size="18" />
                                <div slot="content">
                                    <p>后缀可用于溯源码有特殊指定规则的场景(选填)</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 时效与状态 -->
        <div class="content section-state">
            <div class="section-header">
                <Icon type="ios-settings-outline" size="20" />
                <span>时效与状态</span>
                <span class="section-tip">（选填项，可生成后再修改）</span>
            </div>
            <Form :model="formData" label-position="right" :label-width="140">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="质保期：">
                            <Input
                                class="w200"
                                type="text"
                                v-model="formData.warranty_days"
                                placeholder="请输入质保期"
                                ><span slot="append">天</span></Input
                            >
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="生产时间：">
                            <DatePicker
                                class="w200"
                                :value="formData.productive_time"
                                type="date"
                                placeholder="点击选择时间"
                                @on-change="changeProductiveTime"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="过期时间：">
                            <DatePicker
                                class="w200"
                                :value="formData.expiration_date"
                                type="date"
                                placeholder="点击选择时间"
                                @on-change="changeExpirationDate"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="是否启用：">
                            <i-switch
                                v-model="formData.status"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="2"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="是否生成发货码：">
                            <i-switch
                                v-model="formData.is_delivery"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="0"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                    </Col>
                    <Col span="8" v-if="formData.is_delivery">
                        <FormItem label="发货码长度：">
                            <Input
                                class="w200"
                                type="number"
                                v-model="formData.delivery_length"
                                placeholder="请输入发货码长度"
                            ></Input>
                        </FormItem>
                    </Col>
            
                    <Col span="8">
                        <FormItem label="是否启用密码：">
                            <i-switch
                                v-model="formData.able_key"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="0"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                    </Col>
                    <Col span="8" v-if="formData.able_key">
                        <FormItem label="密码：">
                            <Input
                                class="w200"
                                password
                                type="password"
                                v-model="formData.qrcode_key"
                                placeholder="请输入密码"
                            ></Input>
                        </FormItem>
                    </Col>
                    
                </Row>
            </Form>
        </div>

        <!-- 提交按钮 -->
        <div class="footer">
            <Button
                class="theme-bc theme-default-color btn-submit"
                @click="submitModal"
                :disabled="!isClickable"
                ><Icon type="ios-checkmark-circle-outline" size="18" /> 确定生成</Button
            >
        </div>
    </div>
</template>

<script>
import {
    qrcode_count_create,
    get_options,
} from "@/api/index";
import { getStorages } from "@/utils/helper";
export default {
    data() {
        return {
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                status: 1,
                qrcode_count: "",
                qrcode_length: "",
                qrcode_prefix: "",
                qrcode_suffix: "",
                qrcode_type: 1,
                productive_time: "",
                warranty_days: "",
                expiration_date: "",
                type: 1,
                able_key: 0,
                qrcode_key: "",
                is_delivery: 0,
                delivery_length: "13",
            },
            batchList: [],
            productList: [],
            agentList: [],
            typeList: [
                { id: 1, name: "纯数字" }, 
                { id: 2, name: "英文字母(大小写混合)" },
                { id: 3, name: "英文字母(大小写混合)+数字" }, 
                { id: 4, name: "英文字母(大写)" }, 
                { id: 5, name: "英文字母(大写)+数字" }
            ],
            infos: getStorages("infos"),
            isClickable: true,
            qrcode_length_value: "",
        };
    },
    created() {
        // 特定账号默认开启发货码
        if (this.infos.admin_id == "476") {
            this.formData.is_delivery = 1;
        } else {
            this.formData.is_delivery = 0;
        }
    },
    mounted() {
        this.getOptions();
        if (this.infos.qrcode_length) {
            this.qrcode_length_value = this.infos.qrcode_length;
            this.formData.qrcode_length = this.infos.qrcode_length;
        }
    },
    methods: {
        changeProductiveTime(e) {
            this.formData.productive_time = e || "";
        },
        changeExpirationDate(e) {
            this.formData.expiration_date = e || "";
        },
        getOptions() {
            get_options()
                .then((res) => {
                    this.productList = res.data.product;
                    this.batchList = res.data.batch;
                    this.agentList = res.data.agent;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        submitModal() {
            if (!this.isClickable) return;
            this.isClickable = false;
            setTimeout(() => {
                this.isClickable = true;
            }, 1000);

            const count = Number(this.formData.qrcode_count);
            if (typeof count != "number" || isNaN(count)) {
                this.$Message.error("请填写生成数量数字");
                return;
            }
            qrcode_count_create(this.formData)
                .then((res) => {
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error({
                        content: res.msg,
                        duration: 10,
                        closable: true,
                    });
                });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.content {
    padding: 20px 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
/* 区块标题 */
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    font-weight: 600;
    font-size: 16px;
    color: #333;
}
.section-header i {
    margin-right: 8px;
    color: #666;
}
.section-tip {
    margin-left: 8px;
    font-weight: normal;
    font-size: 13px;
    color: #999;
}
/* 基础关联区块 */
.section-basic {
    border-left: 4px solid #19be6b;
}
.section-basic .section-header i {
    color: #19be6b;
}
/* 溯源码配置区块 */
.section-code {
    border-left: 4px solid #2563eb;
}
.section-code .section-header i {
    color: #2563eb;
}
/* 时效与状态区块 */
.section-state {
    border-left: 4px solid #ff6b00;
}
.section-state .section-header i {
    color: #ff6b00;
}
/* Alert 内标题 */
.alert-title {
    font-weight: bold;
    font-size: 15px;
}
/* 提交按钮区 */
.footer {
    padding: 20px 0;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.btn-submit {
    padding: 5px 40px;
    font-size: 15px;
}
.btn-submit i {
    margin-right: 6px;
}
/* 工具类 */
.cursor-p {
    cursor: pointer;
}
.ml8 {
    margin-left: 8px;
}
.w200 {
    width: 200px;
}
</style>